import { InputMask } from "client/domain/FormBuilder/fields/InputField";

export const dateInputMask: InputMask = [
  /[0-9]/,
  /[0-9]/,
  "-",
  /[0-9]/,
  /[0-9]/,
  "-",
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
];
